Vue.component('panel-closing', {
	props: ["options", "labellang"],
	template:
	'<transition v-if="isActive" name="bounce" enter-active-class="bounceInDown" leave-active-class="bounceOutRight" v-bind:css="options.internal.isAnimationCompatibility">'+
	'<div id="panel-closing">'+
			'<div class="overlay-content text-center">'+
				'<h3>{{ title }}</h3>'+
			'</div>'+
			'<div class="overlay-footer">' +
			'<button @click.prevent="closeView" class="btn pull-left"  >{{ this.labellang.no }}</button>' +
			'<button @click.prevent="closeSession" class="btn btn-info pull-right">{{ this.labellang.yes }}</button>' +
			'</div>' +
	'</div>'+
	'</div>'+
	'</transition>',
	data:function(){
		return {
			isActive:false,
			title: this.labellang.whant_close_chat
		}
	},
	mounted: function() {
		var that = this;
		bus.$on('onShowPanelClosing', function (val) {
			that.contentShow(val);
		})

	},
	methods:{
		contentShow:function(val){
			this.isActive = val;
		},
		closeView: function () {
			this.isActive = false;
		},
		closeSession:function(){
			bus.$emit('changeCloseSession', false);
      bus.$emit('hideRestartButton', true);
      bus.$emit("confirmCloseSession", true);
			this.isActive = false;
			var that = this;
			this.options.internal.requestCloseReason = "customer";
			this.options.internal.requestCloseFromCustomer = true;
			this.$parent.closeSession();
		 }
	}
})
